module.exports = __webpack_public_path__ + "img/CMA.c21f89d3.png";